module.exports = __webpack_public_path__ + "img/9.dfff4908.svg";